import React from 'react'
import fragment from './fragment.graphql'

/**
 * Localized from legacy web components — @hashicorp/react-basic-table v.2.1.2
 */

function BasicTable({ headline, rows }) {
	return (
		<div className="g-basic-table">
			{headline && <h4 className="g-type-display-4">{headline}</h4>}
			<ul>
				{rows.map((row) => (
					<li key={`row-${row.id}`}>
						<span>{row.timeSlot}</span>
						<span>{row.description}</span>
					</li>
				))}
			</ul>
		</div>
	)
}

BasicTable.fragmentSpec = { fragment }

export default BasicTable
